import { Search,CloseRounded as  Edit,  Delete, Visibility } from "@mui/icons-material";
import dayjs from '../../../../utils/dayjs-setup';
import { Button, Card, CardContent, Chip, Collapse, GridLegacy as Grid, IconButton, Input, Modal, Select, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography } from '@mui/material';
import { useState,useEffect, useContext } from "react";
import { AutoCompleteInputWithLabel,  DatePickerInputWithLabel,  InputFile,  InputWithLabel, SelectInputWithLabel } from "../../../../components/form/custom-imputs";
import { ActionTypes, AppContext } from "../../../../store/AppStore";
import { AxiosInstance,  DateFormatString,  DialogType,  FormActions, getLabelMunicipio,getUrlImage } from "../../../../utils/constants";
import * as yup from "yup";
import { ModalFormGenerador } from "../../../../components/form/ModalForm";
import { DetalleSolicitud } from "../../../../components/plataforma/programacion-recogidas/detalle-solicitud";
import { CustomDialog } from "../../../../components/modals/custom-dialog";
import { ListadoPropuestas } from "../../../../components/plataforma/programacion/listado-propuestas";







const productosSchema = yup.object({
  producto:yup.mixed().required(),
  unidad_medida:yup.string().required(),
  cantidad:yup.number().min(1).required(),
  bodega_origen:yup.mixed().required(),
  bodega_destino:yup.mixed().required()
});

const schema = yup.object({
  fecha_recogida: yup.string().required(),
  fecha_entrega_destino: yup.string().required().test({
      name:"fecha_entrega_destino",
      exclusive:true,
      test(value,ctx){
        if ( !ctx.parent?.fecha_recogida  ) {
          return ctx.createError({ message: 'Se debe tener una fecha de recogida' });
        }else{
          if ( !dayjs(value).isValid()  ) {
            return ctx.createError({ message: 'La fecha de entrega no es valida' });
          }else{
            
            if ( dayjs(ctx.parent?.fecha_recogida).isAfter( value ) ){
              return ctx.createError({ message: 'el valor debe ser mayor o igual a la fecha de recogida ' });
            }
          }
        }
        
      
        return true
      }
  }),
  tipo_vehiculo:yup.mixed().required(),
  listado_productos: yup.array(productosSchema).min(1).required(),
  
}).required();
const InitialFilterSearch = {
  rows_per_page:20,
  page_number:0,
  filter_search:""
};

const InitialSolicitudData = {
  fecha_entrega_destino:null,
  fecha_recogida:dayjs().startOf("day"),
  listado_productos:[],
  tipo_vehiculo:null,
}


const ProductosListItem  = ({
  onDeleteIcon,
  producto,
  cantidad,
  unidad_medida,
  bodega_origen,
  bodega_destino
})=>{
  return (<Card sx={{width:'100%',marginBottom:'5px'}} >
      
    <CardContent>
      
      <Grid container >
        <Grid item sx={10} md={10} >
          <Typography variant="p" ><strong>{producto.label}</strong> </Typography> 
          <Typography><strong>Cantidad:</strong> {cantidad} {producto.unidades_medidas?.find( prod_un=>prod_un.value == unidad_medida )?.label}</Typography>
        </Grid>
        <Grid item sx={5} md={5} >
          <Stack direction={"column"} >
            <Typography variant="p" sx={{fontWeight:"bold"}} >Bodega de origen </Typography> 
            <Typography variant="p" >{bodega_origen.label} </Typography> 
          </Stack>
        </Grid>
        <Grid item sx={5} md={5} >
          <Stack direction={"column"} >
            <Typography variant="p" sx={{fontWeight:"bold"}} >Bodega de destino </Typography> 
            <Typography variant="p" >{bodega_destino.label} </Typography>
          </Stack> 
        </Grid>
        <Grid item sx={2} md={2} >
            <IconButton onClick={onDeleteIcon} sx={{background:"red",color:"white"}}   >
              <Delete  />
            </IconButton>
        </Grid>
      </Grid>
        
    </CardContent>
  </Card>)

}

export const ListadoSolicitudesDirectas  = ()=>{

  const [dataSetProdctos,setDataSetProductos] = useState([]);
  const [filterSearchPagination,setFilterSearchPagination] = useState(InitialFilterSearch);
  const [solicitudData,setSolicitudData] = useState({...InitialSolicitudData});
  const [totalRows,setTotalRows] = useState(0);
  const {dispatch,store} = useContext( AppContext );
  const [isVisibleModalDetalle,setIsVisibleModalDetalle] = useState(false);
  const [productoSeleccionado,setProductoSeleccionado] = useState({});
  const [tipoAction,setTipoAction] = useState(FormActions.AGREGAR);
  const [genericDialog,setGenericDialog] = useState({});
  const [isVisibleModalSolicitud,setIsVisibleModalSolicitud] = useState(false);
  const [productosOptions,setProductOption] = useState([]);
  const [unidadesMedidas,setUnidadesMedidas] = useState([]);
  const [tipos_vehiculos,setTiposVehiculos] = useState([]);
  const [bodegas,setBodegas] = useState([]);

    useEffect(()=>{
      loadInitData();
    },[]);
    

    useEffect(()=>{
  
      loadItems( filterSearchPagination.filter_search?false:true );
    },[filterSearchPagination]);


    const loadInitData = async()=>{
      dispatch({
        type:ActionTypes.setLoadingPage,
        data:true
      });
      onLoadTiposVehiculos();
      await loadItems(false);
    
     dispatch({
        type:ActionTypes.setLoadingPage,
        data:false
      });
    }
    
    const loadItems =  async (loading=true)=>{
      setDataSetProductos([]);
      if (loading){
        dispatch({
          type:ActionTypes.setLoadingPage,
          data:true
        });
      }

     let {data:{value}} = await AxiosInstance.post("logistico/get-solicitudes",{
      ...filterSearchPagination,
      page_number:filterSearchPagination.page_number+1
     });
   
     setDataSetProductos([...value.data]);

     setTotalRows(value.total);
     dispatch({
      type:ActionTypes.setLoadingPage,
      data:false
    });
   
    }

    const handleChangePage = (event, newPage) => {
      
      setFilterSearchPagination({...filterSearchPagination,page_number:newPage});
    };

    const handleChangeRowsPerPage = (event) => {
      setFilterSearchPagination({...filterSearchPagination,rows_per_page:parseInt(event.target.value, 10)});
     
    };



    const onShowDetailProduct = (cod_prod)=>{
      setIsVisibleModalDetalle(true);
      let product =  dataSetProdctos.find(prod=>prod.cod === cod_prod);
      setProductoSeleccionado(product);
      setIsVisibleModalDetalle(true);
    }


    const consultarBodega = async(e,valueSearch)=>{
      if (valueSearch.length > 2){
        try{
          const {data:{value}} = await AxiosInstance.post("cotzaciones/obtener-bodegas-filter",{
            search:valueSearch
          });
          setBodegas(value);
          console.log({value});
        }catch(e){
  
        }
      }

     

    }

    const onSaveDataForm = async(typeAction,dataForm)=>{
    
      dataForm.fecha_entrega_destino = dayjs(dataForm.fecha_entrega_destino).format(DateFormatString);
      dataForm.fecha_recogida = dayjs(dataForm.fecha_recogida).format(DateFormatString);
      dataForm.listado_productos = dataForm.listado_productos.map(produ=>({
        bodega_origen:produ.bodega_origen.value,
        cp_origen:produ.bodega_origen.cp_code,
        bodega_destino:produ.bodega_destino.value,
        cp_destino:produ.bodega_destino.cp_code,
        cantidad:produ.cantidad,
        unidad_medida:produ.unidad_medida,
        cod_producto:produ.producto.value

      }));
      console.log({dataForm});
    
 
        let payload =  {...dataForm  };
        console.log({payload});
      
        setIsVisibleModalDetalle(false);
        dispatch({
          type:ActionTypes.setLoadingPage,
          data:true
        });
        AxiosInstance.post("logistico/crear-solicitud-transporte-directa",payload)
        .then(async res=>{
          setIsVisibleModalDetalle(false);
          dispatch({
            type:ActionTypes.setModalInfo,
            data:{
                title:"Solicitud creada",
                message:"Se creo la solicitud de transporte",
                type:DialogType.exitoso,
                isVisible:true
            }
        });
         await loadItems(true);
        })
        .catch(err=>{
          dispatch({
            type:ActionTypes.setModalInfo,
            data:{
                title:"Error",
                message:"Error de comunicacion verifique su conexion a internet",
                type:DialogType.peligro,
                isVisible:true
            }
        });
        }).finally(()=>{
          dispatch({
            type:ActionTypes.setLoadingPage,
            data:false
          });
        });
       
     

    }

    const columnsTable = [
      {
      
       key:"cod",
       keyValue:"cod",
       label:"Cod de la solicitud",
       headerRender:(props)=>props.label,
       bodyRender:(props)=>"#"+props.value,
       typeRow:"string",
       sort:false,
       sortFunction:()=>{},
       sortStatus:"", 

      },
      {
      
        key:"fecha",
        keyValue:"fecha",
        label:"Fecha de recogida",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>dayjs(props.value).format(DateFormatString),
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
      {
      
        key:"fecha_entrega_destino",
        keyValue:"fecha_entrega_destino",
        label:"Fecha de entrega",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>dayjs(props.value).format(DateFormatString),
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
     
       {
      
        key:"routes_num",
        keyValue:"routes_num",
        label:"Numero de rutas",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.item?.route_solicitud?.length,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"total_kg",
        keyValue:"total_kg",
        label:"Total KG ",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value+" KG",
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"total_canastillas",
        keyValue:"total_canastillas",
        label:"Total Canastillas",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value+" CANASTILLAS",
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
     
       {
      
        key:"ind_estado",
        keyValue:"ind_estado",
        label:"Estado",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
     
      
      {
        key:"editar",
        keyValue:"cod",
        label:"Acciones",
        headerRender:(props)=>props.label,
        bodyRender:({value})=><Stack direction={'row'} >
          <Button onClick={e=>onShowDetailProduct(value)} variant="contained" size="small" >Ver</Button>
        </Stack>,
        typeRow:"number",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },  
    ];
   

    const onCloseModal = ()=>{
      setProductoSeleccionado({});
      setIsVisibleModalDetalle(false);
    }

    const ConfirmarSolicitud = (data)=>{
      console.log({data});
      dispatch({
        type:ActionTypes.setLoadingPage,
        data:true
      });
      AxiosInstance.post("logistico/confirmar-solicitud",{
        solicitud_id:data.cod
      }).then(({data})=>{
        loadInitData(true);
        dispatch({
          type:ActionTypes.setModalInfo,
          data:{
              title:"Solicitud enviada",
              message:"Su solicitud ha sido enviada a los proveedores, Pronto recibira propuestas",
              type:DialogType.exitoso,
              isVisible:true
          }
        });
      }).catch(err=>{

        dispatch({
          type:ActionTypes.setModalInfo,
          data:{
              title:"Error",
              message:"Error de comunicacion verifique su conexion a internet",
              type:DialogType.peligro,
              isVisible:true
          }
      });

      }).finally(()=>{
        setGenericDialog({});
        dispatch({
          type:ActionTypes.setLoadingPage,
          data:false
        });
      });
    }

    const LanzarSolicitud = (data)=>{
      
      setGenericDialog({
        isOpened:true,
        title:"¿Esta seguro de enviar la solicitud?",
        content:"Recuerde que si continua, Se enviara la solicitud a todos los proveedores logisticos, Esta accion no se puede reversar",
        actions:[
          {
            title:"Cancelar",
            buttomProps:{
              variant:"contained",
              color:"secondary",
              onClick:()=>setGenericDialog({})
            }
          },
          {
            title:"Continuar",
            buttomProps:{
              variant:"contained",
              color:"primary",
              onClick:evt=>ConfirmarSolicitud(data)
            }
          }
        ]
      });
    }

    const onAproveSolicitud = (cod_solicitud,cod_oferta)=>{
      console.log({
        cod_solicitud,
        cod_oferta
      });

      dispatch({
        type:ActionTypes.setLoadingPage,
        data:true
      });
      AxiosInstance.post("logistico/aceptar-propuesta-transporte",{
        cod_solicitud,
        cod_oferta
      }).then(({data})=>{
        loadInitData();
        dispatch({
          type:ActionTypes.setModalInfo,
          data:{
              title:"Propuesta aceptada",
              message:"Hemos notificado al proveedor que su oferta fue aceptada. ",
              type:DialogType.exitoso,
              isVisible:true
          }
        });
     
      }).catch(err=>{

        dispatch({
          type:ActionTypes.setModalInfo,
          data:{
              title:"Error",
              message:"Error de comunicacion verifique su conexion a internet",
              type:DialogType.peligro,
              isVisible:true
          }
      });
       
      }).finally(()=>{

        dispatch({
          type:ActionTypes.setLoadingPage,
          data:false
        });
      });
    }
    const onOpenedRow = (index)=>{
      let copyDataSet = [...dataSetProdctos];
      copyDataSet[index].isOpened = copyDataSet[index].isOpened?false:true;
      setDataSetProductos(copyDataSet);
    }

    const onSearchProducto = async (e,value_search) => {
      if (value_search && value_search.length > 2) {
          try {
    
              const { data: { value } } = await AxiosInstance.post("maestros/get-producto-filter", {
                  search_query: value_search
              });
             setProductOption(value);
          } catch (e) {
              return [];
          }
    
      }
    }
    const onLoadTiposVehiculos = async (e,value_search) => {
      try {
    
        const { data: { value } } = await AxiosInstance.post("maestros/obtener-tipos-vehiculos", {
          filter_search: value_search
        });
       
       setTiposVehiculos(value.data?.map( tipo_vehiculo =>({value:tipo_vehiculo.cod,label:tipo_vehiculo.descripcion}) ));
    } catch (e) {
        return [];
    }
    }

    const LoadProductoUnidadesMedidas = async(prod)=>{
      setUnidadesMedidas(prod.unidades_medidas);
     
     
    } 

    const configModal =  {
      titleModal: tipoAction === FormActions.AGREGAR? "Crear solicitud directa":'Modificar solicitud directa',
      buttomsAction: tipoAction === FormActions.AGREGAR? [
          {
            title:"Cancelar",
            buttomProps:{
              type:"buttom",
              onClick:()=>setIsVisibleModalSolicitud(false),
              color:"secondary"
          }
          },
          {
            title:"Registrar",
            buttomProps:{ 
              type:"submit",
             // onClick:onSaveDataNewData
            }
          }
      ]:[
        {
          title:"Cancelar",
          buttomProps:{
            type:"buttom",
            color:"secondary",
            onClick:()=>setIsVisibleModalSolicitud(false)
          }
        },
        {
          title:"Guardar cambios",
          buttomProps:{
            type:"submit",
          //  onClick:onSaveModData
          }
        }

      ],
      imputs:[
        {
          key:"fecha_recogida",
          keyValue:"fecha_recogida",
          label:"Fecha de recogida",
          component: DatePickerInputWithLabel,
              inputProps: {
                size:"small",
                typeInput:"date",
                name:'fecha_recogida',
                fullWidth: true,
                isLoading: false,

              }
        },
        {
          key:"fecha_entrega_destino",
          keyValue:"fecha_entrega_destino",
          label:"Fecha de entrega",
          component: DatePickerInputWithLabel,
              inputProps: {
                size:"small",
                typeInput:"date",
                name:'fecha_entrega_destino',
                fullWidth: true,
                isLoading: false,

              }
        },
        {
          key:"tipo_vehiculo",
          keyValue:"tipo_vehiculo",
          label:"Tipo de vehiculo",
          component:SelectInputWithLabel,
         
          inputProps:{
            size:"small",
            typeInput:"select",
            name: 'tipo_vehiculo',
            fullWidth: true,
            items:tipos_vehiculos,
          }
        },

       
      
      ],
      arrayInputs:[
        {
          label:"Productos a transportar",
          key:"listado_productos",
          keyValue:"listado_productos",
          subSchema:productosSchema,
          ItemRender:ProductosListItem,
          inputs:[
            {
              key:"producto",
              keyValue:"producto",
              label:"Producto",
              component:AutoCompleteInputWithLabel,
              callFuncionOnChange:LoadProductoUnidadesMedidas,
              inputProps:{
                size:"small",
                typeInput:"autoComplete",
                name: 'producto',
                fullWidth: true,
                disabled:false,
                isLoading: false,
                onInputChange: onSearchProducto,
                options: productosOptions|| [],
                noOptionsText: "Lista vacia",
                getOptionLabel: (option) => option.label,
                isOptionEqualToValue: (option, value) => option.value === value.value,
                filterOptions:(x) => x,
              }
            },
            {
              key:"cantidad",
              keyValue:"cantidad",
              label:"Cantidad",
              responsiveSize:8,
              component:InputWithLabel,
              inputProps:{
                size:"small",
                type:"text"
              }
            },
            {
              key:"unidad_medida",
              keyValue:"unidad_medida",
              responsiveSize:4,
              label:"Unidad de medida",
              component:SelectInputWithLabel,
              inputProps:{
                size:"small",
                type:"text",
                items:unidadesMedidas
              }
            },
            {
              key:"bodega_origen",
              keyValue:"bodega_origen",
              label:"Bodega de origen",
              responsiveSize:6,
              component:AutoCompleteInputWithLabel,
              inputProps:{
                size:"small",
                typeInput:"autoComplete",
                name: 'bodega_origen',
                fullWidth: true,
                disabled:false,
                isLoading: false,
                onInputChange: consultarBodega,
                options: bodegas|| [],
                noOptionsText: "Lista vacia",
                getOptionLabel: (option) => option.label,
                isOptionEqualToValue: (option, value) => option.value === value.value,
                filterOptions:(x) => x,
              }
            },
            {
              key:"bodega_destino",
              keyValue:"bodega_destino",
              label:"Bodega de destino",
              responsiveSize:6,
              component:AutoCompleteInputWithLabel,
              inputProps:{
                size:"small",
                typeInput:"autoComplete",
                name: 'bodega_destino',
                fullWidth: true,
                disabled:false,
                isLoading: false,
                onInputChange: consultarBodega,
                options: bodegas|| [],
                noOptionsText: "Lista vacia",
                getOptionLabel: (option) => option.label,
                isOptionEqualToValue: (option, value) => option.value === value.value,
                filterOptions:(x) => x,
              }
            },
        
          ]
        },
      
      ]
    } ;

   
    return (<>

    <CustomDialog
    {
      ...genericDialog
    }
    />



    <DetalleSolicitud
    data={productoSeleccionado}
    isOpened={isVisibleModalDetalle}
    onCloseModal={onCloseModal}
    onLaunchSolicitud={LanzarSolicitud}
    />
   
    <Grid container spacing={2} >


     
        <Grid item sm={12} xs={12} md={12} >

          <TableContainer>
               <Table>
            <TableHead>
              <TableRow>
                <TableCell>

                </TableCell>
                {
                  columnsTable.map(colum => <TableCell key={colum.key} >
                    {<colum.headerRender label={colum.label} />}
                  </TableCell>)
                }

              </TableRow>

            </TableHead>
            <TableBody>
              
                 {dataSetProdctos.map( (prod,prod_index)=>
                 [
                  <TableRow key={prod.cod}  >
                  <TableCell>
                   <IconButton onClick={e=>onOpenedRow(prod_index)} ><Visibility /></IconButton>
                  </TableCell>
                 {
                   columnsTable.map(Col=>
                     <TableCell  >
                       {<Col.bodyRender item={prod} value={prod[Col.keyValue]} />}
                    </TableCell>)
                 }

               </TableRow>,
               <TableRow>
                <TableCell colSpan={columnsTable.length} >
                  <Collapse unmountOnExit in={prod.isOpened} >
                        <ListadoPropuestas 
                        cod_solicitud={prod.cod}
                        onAcceptSolicitud={onAproveSolicitud}  
                        data={prod.listado_ofertas} />
                  </Collapse >
                </TableCell>

               </TableRow>
                 ]
                )}
              
            </TableBody>
           
          </Table>
          </TableContainer>
          <TablePagination
          rowsPerPageOptions={[20, 40, 60]}
          component="div"
          count={totalRows}
          rowsPerPage={filterSearchPagination.rows_per_page}
          page={filterSearchPagination.page_number}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />

        </Grid>
    </Grid>
    </>)

}